// Router

import Vue from 'vue'
import Router from 'vue-router'

// Public Pages
import PubHome from '@/views/pub/PubHome.vue'
import PubAbout from '@/views/pub/PubAbout.vue'
import PubAdvertise from '@/views/pub/PubAdvertise.vue';
import PubContact from '@/views/pub/PubContact.vue';
import PubNotFound from '@/views/pub/PubNotFound.vue';
import PubTos from '@/views/pub/PubTos.vue';

// User Pages
import UsrArtList from '@/views/usr/UsrArtList.vue';
import Search from '@/views/Search.vue';
import Upload from '@/components/Upload.vue';

// Admin Pages
import AdmInfo from '@/views/adm/AdmInfo.vue';
import AdmSettings from '@/views/adm/AdmSettings.vue';

// Builder Pages
import BldIco from '@/views/bld/BldIco.vue';
import BldPager from '@/views/bld/BldPager.vue';
import BldMenu from '@/views/bld/BldMenu.vue';
import BldMess from '@/views/bld/BldMess.vue';
import BldComm from '@/views/bld/BldComm.vue';
import BldPopWin from '@/views/bld/BldPopWin.vue';
import BldForm from '@/views/bld/BldForm.vue';
import BldDABug from '@/views/bld/BldDABug.vue';
import BldState from '@/views/bld/BldState.vue';
import BldStartup from '@/views/bld/BldStartup.vue';

import BldSearch from '@/views/bld/BldSearch.vue';
import BldCatPick from '@/views/bld/BldCatPick.vue';
import BldCatPickBtn from '@/views/bld/BldCatPickBtn';
import BldArt from '@/views/bld/BldArt.vue';
import BldAdmEdit from '@/views/bld/BldAdmEdit.vue';
import BldUniPost from '@/views/bld/BldUniPost.vue';
import BldAdmDataSource from '@/views/bld/BldAdmDataSource.vue';
import BldUniInput from '@/views/bld/BldUniInput.vue';
import BldUniDate from '@/views/bld/BldUniDate.vue';

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{path:'/'				,component:PubHome},
		{path:'/home'			,component:PubHome},
		{path:'/about'			,component:PubAbout},
		{path:'/advertise'		,component:PubAdvertise},
		{path:'/contact'		,component:PubContact},
		{path:'/404'			,component:PubNotFound},
		{path:'/tos'			,component:PubTos},

		{path:'/search'			,component:Search},
		{path:'/arts'			,component:UsrArtList},
		{path:'/upload'			,component:Upload},

		{path:'/adm/info'		,component:AdmInfo},
		{path:'/adm/settings'	,component:AdmSettings},

		{path:'/bld/ico'		,component:BldIco},
		{path:'/bld/pager'		,component:BldPager},
		{path:'/bld/menu'		,component:BldMenu},
		{path:'/bld/mess'		,component:BldMess},
		{path:'/bld/comm'		,component:BldComm},
		{path:'/bld/popwin'		,component:BldPopWin},
		{path:'/bld/form'		,component:BldForm},
		{path:'/bld/dabug'		,component:BldDABug},
		{path:'/bld/state'		,component:BldState},
		{path:'/bld/startup'	,component:BldStartup},

		{path:'/bld/search'		,component:BldSearch},
		{path:'/bld/catpick'	,component:BldCatPick},
		{path:'/bld/catpickbtn'	,component:BldCatPickBtn},
		{path:'/bld/art'		,component:BldArt},
		{path:'/bld/admedit'	,component:BldAdmEdit},
		{path:'/bld/unipost'	,component:BldUniPost},
		{path:'/bld/admds'		,component:BldAdmDataSource},
		{path:'/bld/uniinput'	,component:BldUniInput},
		{path:'/bld/unidate'	,component:BldUniDate},

		{path:'*'				,component:PubNotFound},
	]
})
